import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { apiFetch } from "../api/client";
import { Button } from "../components/ui/Button";

export function InviteScreen() {
  const { code } = useParams();
  const [info, setInfo] = useState<{
    orgName?: string;
    role?: string;
    valid?: boolean;
  } | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!code) return;
    void (async () => {
      try {
        const data = await apiFetch<{
          orgName: string;
          role: string;
          valid: boolean;
        }>(`/api/v1/invites/${encodeURIComponent(code)}`);
        setInfo(data);
      } catch (e) {
        setError(e instanceof Error ? e.message : "Invite not found");
      }
    })();
  }, [code]);

  return (
    <div className="auth-wrap">
      <div className="card auth-card stack">
        <h1 className="screen-title">Invite</h1>
        {error ? <p className="legal-flag">{error}</p> : null}
        {info ? (
          <>
            <p>
              Join <strong>{info.orgName}</strong> as {info.role}
            </p>
            <Link to="/signin">
              <Button variant="primary">Continue to sign in</Button>
            </Link>
          </>
        ) : !error ? (
          <p className="muted">Loading…</p>
        ) : null}
      </div>
    </div>
  );
}
